<template>
  <v-row no-gutters>
    <v-col cols="12">
      <admin-wrapper
        :inputs="inputs"
        @save="saveInformation"
        :is-custom-saving="isSaving"
        :disabled="disabled"
        disable-sticky-buttons
      >
        <template #informationTitle.input>
          <v-col cols="6">
            <data-input
              clearable
              :dataType="dataType"
              v-model="name"
              :disabled="disabled"
              dense
              :rules="[v => !!v || v == '0' || 'rules.required']"
            ></data-input>
          </v-col>
        </template>

        <template #informationContent.input>
          <v-col cols="6">
            <tiptap-vuetify
              :disabled="disabled"
              :extensions="extensions"
              v-model="content"
              :placeholder="$i18n.t('admin.infoPlaceholder')"
              :card-props="{ flat: true, outlined: true }"
              style="text-align: left"
            />
          </v-col>
        </template>
      </admin-wrapper>
    </v-col>
  </v-row>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
import {
  TiptapVuetify,
  Bold,
  Italic,
  Underline,
  Paragraph,
  Heading,
  History,
  HardBreak,
  Link,
  ListItem,
  BulletList,
  OrderedList,
} from 'tiptap-vuetify';
import { call, get } from 'vuex-pathify';
export default {
  name: 'InformationAdmin',
  components: { AdminWrapper, TiptapVuetify, DataInput },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSaving: false,
    name: '',
    content: '',
    dataType: { name: 'text', max_length: 30 },
    extensions: [
      Bold,
      Italic,
      Underline,
      Paragraph,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      HardBreak,
      Link,
      History,
      ListItem,
      BulletList,
      OrderedList,
    ],
  }),
  computed: {
    informationName: get('admin/settingsValues@info_module_name'),
    informationContent: get('admin/settingsValues@info_module_content'),
    inputs() {
      return [
        {
          name: 'informationTitle',
          translationPath: 'admin.informationNameTitle',
          subtitle: 'admin.informationNameSubtitle',
          align: 'start',
          isCustom: true,
        },
        {
          name: 'informationContent',
          translationPath: 'admin.informationContent',
          subtitle: 'admin.informationContentSubtitle',
          isCustom: true,
          align: 'start',
        },
      ];
    },
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async saveInformation() {
      this.isSaving = true;
      await Promise.all([
        this.editSingleSetting({ key: 'info_module_name', body: { value: this.name } }),
        this.editSingleSetting({ key: 'info_module_content', body: { value: this.content } }),
      ]);

      this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
        message: this.$i18n.t('success.setInformationSettings'),
      });
      this.content = this.informationContent;
      this.name = this.informationName;
      this.isSaving = false;
    },
  },
  mounted() {
    this.content = this.informationContent;
    this.name = this.informationName;
  },
};
</script>

<style scoped></style>
